import { render } from "./UnreviewedUserClientsPostsTab.vue?vue&type=template&id=645c37ea&ts=true"
import script from "./UnreviewedUserClientsPostsTab.vue?vue&type=script&lang=ts"
export * from "./UnreviewedUserClientsPostsTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRouteTab});
